var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-calculator" }, [
    _c(
      "div",
      { staticClass: "u-push-bottom--large" },
      [
        _c("p", { staticClass: "c-detail c-detail--main" }, [
          _c("span", [_vm._v("Pris bolig:")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(_vm._s(_vm.residencePrice.toLocaleString("nb-NO")) + ",–"),
          ]),
        ]),
        _vm._v(" "),
        _vm.hasComunalPrice
          ? [
              _c(
                "p",
                { staticClass: "c-detail c-detail--sub" },
                [
                  _vm.selector.depositDescription
                    ? [
                        _c(
                          "InfoButton",
                          {
                            attrs: {
                              modal: {
                                title: "Innskudd",
                                description: _vm.selector.depositDescription,
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            Innskudd (" +
                                _vm._s(_vm.depositSize) +
                                "%):\n          "
                            ),
                          ]
                        ),
                      ]
                    : [
                        _c("span", [
                          _vm._v(
                            "Innskudd (" + _vm._s(_vm.depositSize) + "%):"
                          ),
                        ]),
                      ],
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.baseDeposit.toLocaleString("nb-NO")) + ",–"
                    ),
                  ]),
                ],
                2
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.hasComunalPrice
          ? [
              _c(
                "p",
                { staticClass: "c-detail c-detail--sub" },
                [
                  _vm.selector.communalLoanDescription
                    ? [
                        _c(
                          "InfoButton",
                          {
                            attrs: {
                              modal: {
                                title: "Andel felleslån",
                                description:
                                  _vm.selector.communalLoanDescription,
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            Andel felleslån (" +
                                _vm._s(100 - _vm.depositSize) +
                                "%):\n          "
                            ),
                          ]
                        ),
                      ]
                    : [
                        _vm._v(
                          "\n          Andel felleslån (" +
                            _vm._s(100 - _vm.depositSize) +
                            "%):\n        "
                        ),
                      ],
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.baseLoan.toLocaleString("nb-NO")) + ",–"),
                  ]),
                ],
                2
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.hasOptions
          ? _c("p", { staticClass: "c-detail" }, [
              _c("span", [_vm._v("Tilvalg:")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.optionsCost.toLocaleString("nb-NO")) + ",–"),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.residence.costs > 0
          ? _c("p", { staticClass: "c-detail" }, [
              _c("span", [_vm._v("Omkostninger:")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.residence.costs.toLocaleString("nb-NO")) + ",–"
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.hasOptions || _vm.residence.costs >= 0
          ? [
              _c(
                "p",
                {
                  staticClass:
                    "c-calculator__result c-detail u-border-top u-border-bottom u-border-bottom--thick",
                },
                [
                  _c("span", [_vm._v("Totalt:")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.totalPrice.toLocaleString("nb-NO")) + ",–"
                    ),
                  ]),
                ]
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "u-push" },
      [
        _c("h3", [_vm._v("Finansiering")]),
        _vm._v(" "),
        _c("p", [_vm._v("Hvor mye egenkapital har du?")]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "c-detail" },
          [
            _c("span", [_vm._v("Egenkapital:")]),
            _vm._v(" "),
            _c("currency-input", {
              staticClass: "c-detail__number",
              attrs: {
                locale: "nb-NO",
                currency: { suffix: ",–" },
                precision: 0,
                valueAsInteger: true,
                allowNegative: false,
              },
              model: {
                value: _vm.equity,
                callback: function ($$v) {
                  _vm.equity = $$v
                },
                expression: "equity",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.equity,
              expression: "equity",
              modifiers: { number: true },
            },
          ],
          attrs: { max: _vm.totalPrice, type: "range", min: "0", step: "1000" },
          domProps: { value: _vm.equity },
          on: {
            input: _vm.updateMortgage,
            update: function ($event) {
              return _vm.registerEvent(
                "Kalkulator: endre egenandel",
                "Calculator",
                "calculator_equity_range_slider"
              )
            },
            __r: function ($event) {
              _vm.equity = _vm._n($event.target.value)
            },
            blur: function ($event) {
              return _vm.$forceUpdate()
            },
          },
        }),
        _vm._v(" "),
        _vm.hasComunalPrice
          ? [
              _vm.baseDeposit + _vm.optionsCost + _vm.residence.costs >
              _vm.equity
                ? _c("p", [
                    _vm._v("\n        Med "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.equity.toLocaleString("nb-NO"))),
                    ]),
                    _vm._v(
                      " kroner i\n        egenkapital vil det gjenstå\n        "
                    ),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.equityResult.toLocaleString("nb-NO"))),
                    ]),
                    _vm._v(" kroner av\n        innskudd"),
                    _vm.hasOptions
                      ? _c("span", [_vm._v(", tilvalg")])
                      : _vm._e(),
                    _vm.residence.costs !== 0
                      ? _c("span", [_vm._v(" og omkostninger")])
                      : _vm._e(),
                    _vm._v(
                      ". Dette kan\n        du få hjelp i banken for å finansiere, se videre for å estimere\n        lånekostnader.\n      "
                    ),
                  ])
                : _vm.baseDeposit + _vm.optionsCost + _vm.residence.costs ===
                  _vm.equity
                ? _c("p", [
                    _vm._v("\n        Med "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.equity.toLocaleString("nb-NO"))),
                    ]),
                    _vm._v(
                      " kroner i\n        egenkapital vil du kunne løse inn hele innskuddet\n        "
                    ),
                    _vm.hasOptions || _vm.residence.costs !== 0
                      ? _c("span", [_vm._v("og betale for ")])
                      : _vm._e(),
                    _vm.hasOptions
                      ? _c("span", [_vm._v("alle tilvalg og ")])
                      : _vm._e(),
                    _vm.residence.costs !== 0
                      ? _c("span", [_vm._v("omkostninger")])
                      : _vm._e(),
                    _vm._v(".\n      "),
                  ])
                : _c("p", [
                    _vm._v("\n        Med "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.equity.toLocaleString("nb-NO"))),
                    ]),
                    _vm._v(
                      " kroner i\n        egenkapital vil du kunne løse inn hele innskuddet\n        "
                    ),
                    _vm.hasOptions || _vm.residence.costs !== 0
                      ? _c("span", [_vm._v("og betale for ")])
                      : _vm._e(),
                    _vm.hasOptions
                      ? _c("span", [_vm._v("alle tilvalg og ")])
                      : _vm._e(),
                    _vm.residence.costs !== 0
                      ? _c("span", [_vm._v("omkostninger")])
                      : _vm._e(),
                    _vm._v(". Du kan også\n        løse inn\n        "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.equityResult.toLocaleString("nb-NO"))),
                    ]),
                    _vm._v(
                      " kroner av\n        felleslånet slik at det vil gjenstå\n        "
                    ),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.remainingLoan.toLocaleString("nb-NO"))),
                    ]),
                    _vm._v(" kroner.\n      "),
                  ]),
            ]
          : [
              _c("p", [
                _vm._v("\n        Du trenger\n        "),
                _c("strong", [
                  _vm._v(_vm._s(_vm.equityResult.toLocaleString("nb-NO"))),
                ]),
                _vm._v(" kroner i\n        lån for denne boligen.\n      "),
              ]),
            ],
        _vm._v(" "),
        _vm.hasComunalPrice && _vm.hasMortgage && _vm.equity < _vm.baseDeposit
          ? [
              _c("p", { staticClass: "c-detail" }, [
                _c("span", [_vm._v("Lånebeløp banklån:")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.mortgage.toLocaleString()) + ",–"),
                ]),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.mortgage,
                    expression: "mortgage",
                    modifiers: { number: true },
                  },
                ],
                attrs: {
                  min: _vm.mortgageMin,
                  max: _vm.mortgageMax + 1000,
                  type: "range",
                  step: "1000",
                },
                domProps: { value: _vm.mortgage },
                on: {
                  update: function ($event) {
                    return _vm.registerEvent(
                      "Kalkulator: endre lånebeløp",
                      "Calculator",
                      "calculator_mortgage_range_slider"
                    )
                  },
                  __r: function ($event) {
                    _vm.mortgage = _vm._n($event.target.value)
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
            ]
          : _vm._e(),
        _vm._v(" "),
        (_vm.hasComunalPrice &&
          _vm.hasMortgage &&
          _vm.mortgage > 0 &&
          _vm.equity < _vm.baseDeposit) ||
        (!_vm.hasComunalPrice &&
          _vm.hasMortgage &&
          _vm.equity < _vm.baseDeposit)
          ? [
              _c("p", { staticClass: "c-detail" }, [
                _c("span", [_vm._v("Rentesats banklån:")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.mortgageInterestRate) + " %")]),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.mortgageInterestRate,
                    expression: "mortgageInterestRate",
                    modifiers: { number: true },
                  },
                ],
                attrs: { type: "range", min: "0.5", max: "10", step: "0.1" },
                domProps: { value: _vm.mortgageInterestRate },
                on: {
                  update: function ($event) {
                    "Kalkulator: endre rentesats",
                      "Calculator",
                      "calculator_interest_rate_range_slider"
                  },
                  __r: function ($event) {
                    _vm.mortgageInterestRate = _vm._n($event.target.value)
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
            ]
          : _vm._e(),
        _vm._v(" "),
        (_vm.hasComunalPrice &&
          _vm.hasMortgage &&
          _vm.mortgage > 0 &&
          _vm.equity < _vm.baseDeposit) ||
        (!_vm.hasComunalPrice &&
          _vm.hasMortgage &&
          _vm.equity < _vm.baseDeposit)
          ? [
              _c("p", { staticClass: "c-detail" }, [
                _c("span", [_vm._v("Nedbetalingstid banklån:")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.mortgageYears) + " år")]),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.mortgageYears,
                    expression: "mortgageYears",
                    modifiers: { number: true },
                  },
                ],
                attrs: { type: "range", min: "1", max: "30", step: "1" },
                domProps: { value: _vm.mortgageYears },
                on: {
                  update: function ($event) {
                    "Kalkulator: endre nedbetalingsperiode",
                      "Calculator",
                      "calculator_mortgage_years_range_slider"
                  },
                  __r: function ($event) {
                    _vm.mortgageYears = _vm._n($event.target.value)
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.hasComunalPrice &&
        _vm.hasMortgage &&
        _vm.mortgage > 0 &&
        _vm.equity < _vm.baseDeposit
          ? [
              _c("p", [
                _vm._v("\n        Hvis du låner\n        "),
                _c("strong", [
                  _vm._v(_vm._s(_vm.mortgage.toLocaleString("nb-NO"))),
                ]),
                _vm._v(" vil det\n        gjenstå\n        "),
                _c("strong", [
                  _vm._v(_vm._s(_vm.remainingLoan.toLocaleString("nb-NO"))),
                ]),
                _vm._v(" kroner i\n        felleslån.\n      "),
              ]),
            ]
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "u-push" },
      [
        _c("h3", [_vm._v("Du betaler i måneden")]),
        _vm._v(" "),
        _c("nav", { staticClass: "c-toggles" }, [
          _vm.hasMortgage && _vm.mortgage > 0
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.showMortgageCost,
                    expression: "showMortgageCost",
                  },
                ],
                attrs: { id: "toggleMortgage", type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.showMortgageCost)
                    ? _vm._i(_vm.showMortgageCost, null) > -1
                    : _vm.showMortgageCost,
                },
                on: {
                  input: function ($event) {
                    return _vm.registerEvent(
                      "Kalkulator: vis/skjul månedskost banklån",
                      "Calculator",
                      "calculator_mortgage_check"
                    )
                  },
                  change: function ($event) {
                    var $$a = _vm.showMortgageCost,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.showMortgageCost = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.showMortgageCost = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.showMortgageCost = $$c
                    }
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasMortgage && _vm.mortgage > 0
            ? _c(
                "label",
                { attrs: { for: "toggleMortgage" } },
                [
                  _vm.showMortgageCost
                    ? [_vm._v(" Skjul banklån ")]
                    : [
                        _vm._v(
                          "\n          Vis utgifter banklån (første " +
                            _vm._s(_vm.mortgageYears) +
                            " år)\n        "
                        ),
                      ],
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasComunalPrice && _vm.installmentFreeYears > 0
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.showLoanInstallmentCost,
                    expression: "showLoanInstallmentCost",
                  },
                ],
                attrs: { id: "toggleInstallment", type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.showLoanInstallmentCost)
                    ? _vm._i(_vm.showLoanInstallmentCost, null) > -1
                    : _vm.showLoanInstallmentCost,
                },
                on: {
                  input: function ($event) {
                    return _vm.registerEvent(
                      "Kalkulator: vis/skjul avdragskostnad felleslån",
                      "Calculator",
                      "calculator_loan_check"
                    )
                  },
                  change: function ($event) {
                    var $$a = _vm.showLoanInstallmentCost,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          (_vm.showLoanInstallmentCost = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.showLoanInstallmentCost = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.showLoanInstallmentCost = $$c
                    }
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasComunalPrice && _vm.installmentFreeYears > 0
            ? _c(
                "label",
                { attrs: { for: "toggleInstallment" } },
                [
                  _vm.showLoanInstallmentCost
                    ? [_vm._v("\n          Skjul avdrag felleslån\n        ")]
                    : [
                        _vm._v(
                          "\n          Vis felleslån med avdrag (utgifter etter\n          " +
                            _vm._s(_vm.installmentFreeYears) +
                            " år)\n        "
                        ),
                      ],
                ],
                2
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.showMortgageCost
          ? [
              _c(
                "p",
                { staticClass: "c-detail" },
                [
                  _vm.selector.individualLoanDescription
                    ? [
                        _c(
                          "InfoButton",
                          {
                            attrs: {
                              modal: {
                                title: "Banklån",
                                description:
                                  _vm.selector.individualLoanDescription,
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            Renter og avdrag banklån:\n          "
                            ),
                          ]
                        ),
                      ]
                    : [_c("span", [_vm._v("Renter og avdrag banklån:")])],
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.monthlyMortgage.toLocaleString("nb-NO")) + ",–"
                    ),
                  ]),
                ],
                2
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.showLoanInterestCost
          ? [
              _c(
                "p",
                { staticClass: "c-detail" },
                [
                  _vm.selector.interestRateComunalDescription
                    ? [
                        _c(
                          "InfoButton",
                          {
                            attrs: {
                              modal: {
                                title: "Felleslån",
                                description:
                                  _vm.selector.interestRateComunalDescription,
                              },
                            },
                          },
                          [
                            _vm._v("\n            Renter\n            "),
                            _vm.showLoanInstallmentCost
                              ? _c("span", [_vm._v(" og avdrag ")])
                              : _vm._e(),
                            _vm._v(" felleslån:\n          "),
                          ]
                        ),
                      ]
                    : [
                        _c(
                          "span",
                          [
                            _vm._v("\n            Renter\n            "),
                            _vm.showLoanInstallmentCost
                              ? [_vm._v(" og avdrag ")]
                              : _vm._e(),
                            _vm._v("\n            felleslån:\n          "),
                          ],
                          2
                        ),
                      ],
                  _vm._v(" "),
                  _vm.showLoanInterestCost &&
                  _vm.showLoanInstallmentCost === false
                    ? _c("span", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.monthlyInterest.toLocaleString("nb-NO")
                            ) +
                            ",–\n        "
                        ),
                      ])
                    : _c("span", [
                        _vm._v(
                          _vm._s(_vm.monthlyLoan.toLocaleString("nb-NO")) + ",–"
                        ),
                      ]),
                ],
                2
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.showFixedCost
          ? _c(
              "p",
              { staticClass: "c-detail" },
              [
                _vm.selector.monthlyCostsDescription
                  ? [
                      _c(
                        "InfoButton",
                        {
                          attrs: {
                            modal: {
                              title: "Fellesutgifter",
                              description: _vm.selector.monthlyCostsDescription,
                            },
                          },
                        },
                        [_vm._v("\n          Fellesutgifter\n        ")]
                      ),
                    ]
                  : [
                      _c("span", { staticClass: "c-infobox__title" }, [
                        _vm._v("Fellesutgifter"),
                      ]),
                    ],
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.fixedMonthlyCost.toLocaleString("nb-NO")) + ",–"
                  ),
                ]),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass:
              "c-calculator__result c-detail u-border-top u-border-bottom u-border-bottom--thick",
          },
          [
            _c("strong", [_vm._v("Til sammen:")]),
            _vm._v(" "),
            _c("strong", [
              _vm._v(_vm._s(_vm.totalMonthly.toLocaleString("nb-NO")) + ",–"),
            ]),
          ]
        ),
        _vm._v(" "),
        _vm.selector.taxDeductionCheck
          ? [
              _c(
                "p",
                { staticClass: "c-detail" },
                [
                  _vm.selector.taxDeductionDescription
                    ? [
                        _c(
                          "InfoButton",
                          {
                            attrs: {
                              modal: {
                                title: "Skattefradrag",
                                description:
                                  _vm.selector.taxDeductionDescription,
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            Etter skattefradrag:\n          "
                            ),
                          ]
                        ),
                      ]
                    : [_c("span", [_vm._v("Etter skattefradrag:")])],
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.totalMonthlyAfterTaxReduction.toLocaleString(
                            "nb-NO"
                          )
                        ) +
                        ",–\n        "
                    ),
                  ]),
                ],
                2
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }